import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { FormattedMessage } from "react-intl";
import { Subscribe } from "unstated";

import { myGlobals } from "../../Utils";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

import { callReduxAlertAction } from "../../App";
import { store as reduxStore } from "../../redux/store";
import { myUtilities } from "../../Utils";

import { CreditCardPaymentLoading } from "./"; 

class CreditCardPaymentDIPage extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.requestSent = false;
    this.state = {
      status: "loading",
    };
    this.configs = null;
  }
  responseHandler = (data) => {
  	if(data != undefined && data.rows != undefined && data.rows.failureReason && data.rows.failureReason === 'LINK_EXPIRED'){
  		myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
      myGlobals.getHistory.replace(`/linkExpired`);
      return;
    }
    if (data != undefined && data.rows != undefined && data.success) {
      this.configs = data.rows;
      if (
        this.configs["IS_PAYMENT_BLOCKED"].toString().localeCompare("true") ===
        0 ||
        (this.configs["MULTI_TOKEN_PROCESSORS"] !== undefined && 
         this.configs["MULTI_TOKEN_PROCESSORS"].toString().localeCompare("true") === 0)
      ) {
        this.setState({
          status: "paymentBlocked",
        });
      } else {
        this.setState({
          status: "show",
        });
      }
    } else
      this.setState({
        status: "failure",
      });
  };
  getCreditCardConfigsForAccount = (invData, paymentData, responseHandler) => {
    let searchParams;
    if (invData.state.paymentOnAccount) {
      let totalConvienceFee = paymentData.state.totalConvienceFee;
      if (totalConvienceFee === null) totalConvienceFee = 0;
      let surcharge = paymentData.state.totalSurchargeAmount;
      if (surcharge === null) surcharge = 0;
      let remittanceFormData = invData.state.remittanceFormData;
      searchParams = new URLSearchParams();
      searchParams.append("isFromAPBill", window.rsaEncrypt(false));
      searchParams.append(
        "supplierId",
        window.rsaEncrypt(invData.state.onDemandAccountId)
      );
      searchParams.append("isSupplier", window.rsaEncrypt(true));
      searchParams.append(
        "customerMapId",
        window.rsaEncrypt(invData.state.pkMcarId)
      );
      searchParams.append("saveCreditCardForReUse", window.rsaEncrypt(false));
      searchParams.append(
        "currency",
        window.rsaEncrypt(invData.state.currency)
      );
      searchParams.append(
        "paymentAmount",
        window.rsaEncrypt(parseFloat(invData.state.payableAmount))
      ); //removing addition of conv fee and surcharge due to eipp changes
      searchParams.append(
        "convenienceFee",
        window.rsaEncrypt(totalConvienceFee)
      );
      searchParams.append("surcharge", window.rsaEncrypt(surcharge));
      searchParams.append("isPaymentOnAccount", window.rsaEncrypt(true));
      searchParams.append("payThroughEmail", window.rsaEncrypt(true));
      searchParams.append("publicKey", invData.state.publicKey);
      searchParams.append("token", window.rsaEncrypt(myGlobals.token));

      if (remittanceFormData !== null) {
        const keys = Object.keys(remittanceFormData);
        for (let i = 0; i < keys.length; ++i) {
          searchParams.append(
            keys[i],
            window.rsaEncrypt(remittanceFormData[keys[i]])
          );
        }
      }
    } else {
      let invoices = invData.state.selectedInvoices;
      let selectedBills = "";
      let selectedBills1 = "";
      let currency = invoices[0].currency;
      let totalVal = invData.getTotalInvoiceAmount(invoices);
      let totalConvienceFee = paymentData.state.totalConvienceFee;
      if (totalConvienceFee === null) {
        totalConvienceFee = 0;
      }
      let surcharge = paymentData.state.totalSurchargeAmount;
      if (surcharge === null) surcharge = 0;
      const partialPaymentEnabled = invData.state.partialPaymentEnabledForGuestPay === true;
      invoices.forEach((invoice) => {
        const originalAmt = invoice.payableAmount2 !== undefined ? invoice.payableAmount2 : invoice.payableAmount;
        if (partialPaymentEnabled) {
          const isPartialEdited = parseFloat(invoice.payableAmount) < parseFloat(originalAmt);
          const disputeAmt = isPartialEdited ? invoice.payableAmount : originalAmt;
          const reasonCode = (isPartialEdited && invoice.partialPaymentReason) ? invoice.partialPaymentReason : null;
          const comments = (isPartialEdited && reasonCode) ? (invoice.partialPaymentComments || null) : null;
          selectedBills += "&&" + invoice.accountDocHeaderId + "@" + originalAmt + "@" + disputeAmt + "@" + reasonCode + "@" + comments;
        } else {
          let dispute = invoice.disputeAmount;
          let reasonCodeId = invoice.reasonCodeId;
          let comments = "";
          if (dispute === undefined || dispute === null) dispute = "";
          if (
            reasonCodeId === undefined ||
            reasonCodeId === null ||
            reasonCodeId === 0
          )
            reasonCodeId = "";
          selectedBills +=
            "&&" +
            invoice.accountDocHeaderId +
            "@" +
            originalAmt +
            "@" +
            dispute +
            "@" +
            reasonCodeId +
            "@" +
            comments;
        }
      });

      let length = selectedBills.length;
      let selectedBillsBackup = selectedBills;
      let i = 0;
      while (length > 0) {
        if (length > 245) {
          selectedBills1 =
            selectedBills1 +
            "||" +
            window.rsaEncrypt(selectedBillsBackup.substring(0, 245));
          selectedBillsBackup = selectedBillsBackup.substring(245, length);
          length = length - 245;
        } else {
          selectedBills1 =
            selectedBills1 +
            "||" +
            window.rsaEncrypt(selectedBillsBackup.substring(0, length));
          length = 0;
        }
        i = i + 1;
      }

      searchParams = new URLSearchParams();
      searchParams.append(
        "supplierId",
        window.rsaEncrypt(invData.state.onDemandAccountId)
      );
      searchParams.append(
        "customerMapId",
        window.rsaEncrypt(invData.state.pkMcarId)
      );
      searchParams.append("selectedBills", selectedBills1);
      searchParams.append("saveCreditCardForReUse", window.rsaEncrypt(false));
      searchParams.append("currency", window.rsaEncrypt(currency));
      searchParams.append("isSupplier", window.rsaEncrypt(true));
      searchParams.append("paymentAmount", window.rsaEncrypt(totalVal));
      searchParams.append(
        "convenienceFee",
        window.rsaEncrypt(totalConvienceFee)
      );
      searchParams.append("isPaymentOnAccount", window.rsaEncrypt(false));
      searchParams.append("isFromAPBill", window.rsaEncrypt(false));
      searchParams.append(
        "globalAccountId",
        window.rsaEncrypt(invData.state.globalAccountId)
      );
      searchParams.append("payThroughEmail", window.rsaEncrypt(true));
      searchParams.append("publicKey", invData.state.publicKey);
      searchParams.append("surcharge", window.rsaEncrypt(surcharge));
      searchParams.append("token", window.rsaEncrypt(myGlobals.token));
    }
    searchParams.append("cardType", window.rsaEncrypt(paymentData.state.cardType));
    if(invData.state?.multipleTransactionsPerMID)
    {
		searchParams.append("multipleTransactionsPerMID", window.rsaEncrypt(invData.state.multipleTransactionsPerMID));
	}
    if (!this.requestSent && this.state.status.localeCompare("loading") === 0) {
    let link = !paymentData.state.isDCFlow ? 
                "newCreditCardConfigurationsWithoutLogin" : 
                "newDebitCardConfigurationsWithoutLogin";
      link = myGlobals.initialHost + myGlobals.appender + link;
      fetch(link, {
        //https://api.jsonbin.io/b/5ec64ded18c8475bf16d7db8
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          return response.json();
        })
        .then(function (data) {
          responseHandler(data);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          //onFailure(err);
        });
      this.requestSent = true;
    }
  };
  componentDidUpdate() {
    if (this.state.status.localeCompare("show") === 0)
      this.formRef.current.submit();
  }
  insertInputs = (invdata) => {
    delete this.configs["BILL_TO_CITY"];
    delete this.configs["BILL_TO_COUNTRY"];
    delete this.configs["BILL_TO_POSTAL_CODE"];
    delete this.configs["BILL_TO_PHONE"];
    delete this.configs["BILL_TO_FIRST_NAME"];
    delete this.configs["BILL_TO_STATE"];
    delete this.configs["BILL_TO_EMAIL"];
    delete this.configs["BILL_TO_LAST_NAME"];
    delete this.configs["BILL_TO_STREET2"];
    delete this.configs["BILL_TO_STREET1"];
    delete this.configs["JS_FILE_NAME"];
    delete this.configs["CSS_FILE_NAME"];
    const keys = Object.keys(this.configs);
    let inputs = [];
    for (let i = 0; i < keys.length; ++i) {
      if (keys[i].localeCompare("LANGUAGE_CODE") != 0) {
        if (keys[i].localeCompare("PROCESSOR_MERCHANT_VALUES") === 0) {
          let processors = this.configs[keys[i]];
          if (
            invdata.state.onDemandAccountId !== null &&
            invdata.state.onDemandAccountId !== undefined &&
            invdata.state.onDemandAccountId
              .toString()
              .localeCompare("70651") === 0
          ) {
            inputs.push(
              <input
                key={processors[0]}
                type="hidden"
                name={keys[i]}
                value={processors[0]}
              />
            );
          } else {
            for (let j = 0; j < processors.length; ++j) {
              inputs.push(
                <input
                  key={processors[j]}
                  type="hidden"
                  name={keys[i]}
                  value={processors[j]}
                />
              );
            }
          }
        } else {
          inputs.push(
            <input
              key={keys[i]}
              type="hidden"
              name={keys[i]}
              value={this.configs[keys[i]]}
            />
          );
        }
      }
    }
    if (keys.indexOf("JS_FILE_NAME") === -1) {
      if (myGlobals.languageCode.localeCompare("en") !== 0) {
        inputs.push(
          <input
            key="JS_FILE_NAME"
            type="hidden"
            name="JS_FILE_NAME"
            value={ reduxStore.getState().styleNames.CC_DI_JS + "_" + myGlobals.languageCode}
          />
        );
      } else {
        inputs.push(
          <input
            key="JS_FILE_NAME"
            type="hidden"
            name="JS_FILE_NAME"
            value={reduxStore.getState().styleNames.CC_DI_JS}
          />
        );
      }
    }

    if (myGlobals.languageCode.localeCompare("en") !== 0) {
      inputs.push(
        <input
          key="CSS_FILE_NAME"
          type="hidden"
          name="CSS_FILE_NAME"
          value={ reduxStore.getState().styleNames.CC_DI_CSS + "_" + myGlobals.languageCode}
        />
      );
    } else {
      inputs.push(
        <input
          key="CSS_FILE_NAME"
          type="hidden"
          name="CSS_FILE_NAME"
          value= {reduxStore.getState().styleNames.CC_DI_CSS}
        />
      );
    }
    inputs.push(
      <input
        key="LANGUAGE_CODE"
        type="hidden"
        name="LANGUAGE_CODE"
        value={myGlobals.pmtLanguageCode}
      />
    );
    return inputs;
  };
  createForm = (invdata) => {
    let action = this.configs.PAYMENT_DI[0];
    //action = action.substring(0,action.lastIndexOf("/"));
    //action+='/v2/checkOut.do';
    return (
      <Row>
        <Col sm={12}>
          <form
            ref={this.formRef}
            id="moodleform"
            target="myiframe"
            method="post"
            action={action}
          >
            {this.insertInputs(invdata)}
          </form>
          <iframe
            id="myiframe"
            name="myiframe"
            width="100%"
            height={(70 / 100) * window.screen.height}
            frameBorder="0"
          ></iframe>
        </Col>
      </Row>
    );
  };
  showContentBasedOnStatus = (invdata) => {
    if (this.state.status.localeCompare("loading") === 0) {
     /* return (
        <div>
          <FormattedMessage
            id="CreditCard.Loading.DIPage"
            defaultMessage="Loading in DI Page"
          />
        </div>
      );*/
    	return <CreditCardPaymentLoading />;
    } else if (this.state.status.localeCompare("show") === 0) {
      return this.createForm(invdata);
    } else if (this.state.status.localeCompare("failure") === 0) {
      return (
        <div>
          <FormattedMessage
            id="CreditCard.FailedDIPage"
            defaultMessage="Failed to get DI Page Configs"
          />
        </div>
      );
    } else if (this.state.status.localeCompare("paymentBlocked") === 0) {
      callReduxAlertAction(
        "Validation.CC3Ds.Alert",
        "The invoices cannot be paid together. Please contact administrator"
      );
      window.location = myGlobals.initialLink;
    }
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <Container>
                {this.getCreditCardConfigsForAccount(
                  invdata,
                  data,
                  this.responseHandler
                )}
                {this.showContentBasedOnStatus(invdata)}
              </Container>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
}

export default CreditCardPaymentDIPage;
